function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 64 64",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_1095_23693)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.333 23.267c0-12.126 9.838-21.933 22-21.933 12.163 0 22 9.807 22 21.933 0 16.45-22 40.733-22 40.733s-22-24.283-22-40.733z",
  fill: "#359942"
}), /*#__PURE__*/React.createElement("rect", {
  x: "14.667",
  y: "6.667",
  width: "33.333",
  height: "33.333",
  rx: "16.667",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M31.333 17.233a2.1 2.1 0 110 4.2 2.1 2.1 0 010-4.2zm0 9c2.97 0 6.1 1.46 6.1 2.1v1.1h-12.2v-1.1c0-.64 3.13-2.1 6.1-2.1zm0-10.9c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 9c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4z",
  fill: "#359942"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1095_23693"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h64v64H0z"
})))));